import { APIURL } from "./config";

export const getSectionsByQuestionnaire = async (questionnaireId: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/questionnaire/${questionnaireId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

export const getSectionsByTemplate = async (templateId: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/template/${templateId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

export const getSection = async (sectionId: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

export const createSection = async (sectionData: any, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(sectionData),
  });
  return res.json();
};

export const createSectionsBulk = async (sectionsData: any[], token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/bulk`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(sectionsData),
  });
  return res.json();
};

export const updateSection = async (sectionId: string, sectionData: any, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(sectionData),
  });
  return res;
};

export const deleteSection = async (sectionId: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const addQuestionsToSection = async (sectionId: string, questionMappingIds: string[], token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}/questions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(questionMappingIds),
  });
  return res;
};

export const reorderQuestionsInSection = async (sectionId: string, questionMappingIds: string[], token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}/questions/reorder`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(questionMappingIds),
  });
  return res;
};

export const removeQuestionsFromSection = async (sectionId: string, questionMappingIds: string[], token: string) => {
  const res = await fetch(`${APIURL}/AssessmentSection/${sectionId}/questions`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(questionMappingIds),
  });
  return res;
};
